import { cn } from '@/lib/utils'

import { CurrentDocumentForms } from './ui/current-document-forms/current-document-forms'
import { CurrentDocument } from './ui/current-document/current-document'
import { DocumentList } from './ui/document-list/document-list'
import { useProcessDocumentReviewPage } from './use-page'

export const ProcessDocumentReviewPage = () => {
  const { ocrDocumentList } = useProcessDocumentReviewPage()

  return (
    <div className={cn('flex', 'bg-slate-100', 'w-full', 'h-full', 'overflow-x-auto')}>
      <div className={cn('min-w-[215px] max-w-[215px]', 'px-3 py-5')}>
        <DocumentList items={ocrDocumentList} />
      </div>

      <div className={cn('flex-1', 'p-5')}>
        <CurrentDocument />
      </div>

      <div className={cn('py-5 pr-5')}>
        <CurrentDocumentForms />
      </div>
    </div>
  )
}
